export default __webpack_public_path__ + "static/media/receipt.fc75241f.png";